import React from 'react';
import request from 'superagent';
import { compose, withState, withHandlers } from 'recompose';
import { Translate, I18n } from 'react-redux-i18n';

import { trackYandexGoal } from '../../actions/utils';
import isEmail from 'validator/lib/isEmail';
import Modal from '../Modal';

import PhoneInput from '../shop/PhoneInput';

const nameState = withState('name', 'setName', '');
const emailState = withState('email', 'setEmail', '');
const phoneState = withState('phone', 'setPhone', '');
const typeState = withState('type', 'setType', 'phone');
const messageState = withState('message', 'setMessage', '');
const resultState = withState('result', 'setResult', 'notSend');
const highlightInvalid = withState('highlight', 'setHighlight', false);

const contactHandler = withHandlers({
  contactUs: ({
    email,
    name,
    phone,
    type,
    message,
    theme,
    setResult,
    setHighlight,
    key,
  }) => event => {
    event.preventDefault();

    const emailValid = isEmail(email);
    if (!email || !emailValid || !phone) {
      setHighlight(true);
    } else {
      trackYandexGoal(`submit-contact-me${key ? ' ' + key : ''}`);
      request
        .post('/mail/contactme')
        .send({ email, phone, type, message, theme })
        .end((err, res) => {
          if (err) setResult('error');
          else {
            if (res.ok) {
              setResult('invite');
            } else {
              setResult('ok');
            }
          }
        });
    }
  },
});

const composedContactState = compose(
  nameState,
  emailState,
  phoneState,
  typeState,
  messageState,
  resultState,
  highlightInvalid,
  contactHandler
);

export const ContactForm = composedContactState(
  ({
    short,
    buttonClass,
    buttonText,
    textKey,
    name,
    setName,
    email,
    setEmail,
    phone,
    setPhone,
    type,
    setType,
    message,
    setMessage,
    contactUs,
    result,
    highlight,
  }) => {
    let emailClass = '';
    let emailMessage = '';
    const emailValid = isEmail(email);

    if ((email && !emailValid) || highlight) {
      emailClass = emailValid ? 'has-success' : 'has-error';
      if (!emailValid) {
        emailMessage = <Translate value="register.errors.email.wrong" />;
      }
    }

    return (
      <div className="row text-left">
        {result === 'notSend' ? (
          <form className="col-xs-12" autoComplete="off">
            {!short && (
              <p className="text-header">
                <Translate
                  value={`static.contactModal.${
                    textKey ? textKey : 'default'
                  }.header.0`}
                />
                &nbsp;
                <br className="hidden-xs" />
                <Translate
                  value={`static.contactModal.${
                    textKey ? textKey : 'default'
                  }.header.1`}
                />
              </p>
            )}
            {/* <div className={`${nameClass}`}>
              <input
                type="text"
                className="form-control"
                placeholder={I18n.t('static.contactModal.parentName')}
                autoComplete="new-password"
                value={name}
                name="name"
                onChange={e => {
                  setName(e.target.value);
                }}
              />
              <span className="help-block" style={{ margin: 0 }}>
                {nameMessage}
              </span>
            </div>
            <br /> */}
            <div className={`${emailClass}`}>
              <input
                type="email"
                className="form-control"
                placeholder={I18n.t('static.contactModal.parentEmail')}
                autoComplete="new-password"
                value={email}
                name="email"
                onChange={e => setEmail(e.target.value)}
              />
              <span className="help-block" style={{ margin: 0 }}>
                {emailMessage}
              </span>
            </div>
            <br />
            <div className={`${emailClass}`}>
              <input
                type="text"
                className="form-control"
                placeholder={I18n.t('static.contactModal.comment')}
                autoComplete="new-password"
                value={message}
                name="message"
                onChange={e => setMessage(e.target.value)}
              />
              <span className="help-block" style={{ margin: 0 }}></span>
            </div>
            <br />
            <div>
              <PhoneInput
                phone={phone}
                hideLabel={true}
                highlight={highlight}
                callback={phone => setPhone(phone)}
              />
            </div>

            {/* !short && (
              <React.Fragment>
                <div className="flex-form-input">
                  <label
                    className="text-header"
                    style={{ padding: 0, minWidth: '150px' }}
                  >
                    Способ связи: &nbsp;&nbsp;{' '}
                  </label>
                  <select
                    className="form-control"
                    onChange={e => setType(e.target.value)}
                  >
                    <option value="phone"> Позвоните мне </option>
                    <option value="whatsapp"> WhatsApp </option>
                    <option value="viber"> Viber </option>
                    <option value="telegram"> Telegram </option>
                  </select>
                </div>

                <br />
                <textarea
                  className="form-control"
                  autoComplete="new-password"
                  rows={3}
                  placeholder="Комментарий (например, удобное время для звонка)"
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                />
                <br />
              </React.Fragment>
            ) */}

            <button
              className={
                buttonClass
                  ? buttonClass
                  : 'btn btn-green btn-medium btn-block text-uppercase'
              }
              onClick={contactUs}
            >
              {buttonText
                ? buttonText
                : I18n.t('static.contactModal.submitApplication')}
            </button>
            <br />

            {!short && (
              <div className="footer text-muted">
                {I18n.t('static.contactModal.byClickedButton')} &nbsp;
                <a href="/docs/policy.doc" download>
                  {I18n.t('static.contactModal.privacyPolicy')}
                </a>
              </div>
            )}
          </form>
        ) : result === 'ok' ? (
          <div className="col-xs-12">
            <p className="text-header">
              {I18n.t('static.contactModal.success')}
            </p>

            <p className="text-header">
              {I18n.t('static.contactModal.hasQuestions')}
            </p>
          </div>
        ) : result === 'invite' ? (
          <div className="col-xs-12">
            <p className="text-header">
              {I18n.t('static.contactModal.success')}
            </p>
          </div>
        ) : (
          <div className="col-xs-12">
            <p className="text-header">
              <Translate value="static.contactModal.error" dangerousHTML />
            </p>
          </div>
        )}
      </div>
    );
  }
);

export const ContactModal = ({ show, close, ...other }) => {
  return (
    <Modal
      show={show}
      close={close}
      hideClose={true}
      dialogClassName="with-robot-head"
      id="modal-contact-me"
    >
      <div className="container-fluid modal-robot-body text-center">
        <div className="robot-head">
          <img
            src={require('../../assets/images/landing/robot-head.svg')}
            alt="progkids-green-robot"
          />
        </div>
        <br />

        <ContactForm {...other} />
      </div>
    </Modal>
  );
};

export default ContactModal;
